import { useEffect, useState } from "react";
import _ from "underscore";
import services from "../../../services/services";
import { Urls } from "../../../services/Urls";

export const useAgileMatrixHeatmap = ({ filterValues, setFilterValues, fromOther }) => {
    const [selectedTab, setSelectedTab] = useState("performance");
    const [tooltip, setTooltip] = useState({ data: {} });
    const [loader, setLoader] = useState(false);
    const [taskDetails, setTaskDetails] = useState({ visible: false, data: [] });
    const tabs = [
        { key: "performance", label: "Performance" },
        { key: "task", label: "Task" },
        { key: "bid", label: "Bid" },
        { key: "best_performance", label: "Best Performance" },
    ]
    const [data, setData] = useState({ matrixData: [], historyData: [], taskData: [] });
    const columns = [
        {
            key: "sr_no",
            label: "Sr No.",
            style: { width: "50px", textAlign: "center" }
        },
        {
            key: "issue_key",
            label: "Issue Key",
            style: { width: "130px" },
            render: (row) => <div className="w100 fw-semibold d-flex gap-1 align-items-center">
                <div><img src={row?.issue_type_image_url} alt="" width={20} height={20}/></div>
                <a href={row?.issue_url} target="_black" className="text-truncate">{row?.issue_key}</a>
            </div>
        },
        {
            key: "issue_summary",
            label: "Issue Summary",
            style: { width: "400px" },
            render: (row) => <div className="w100 text-truncate" title={row?.issue_summary}>{row?.issue_summary}</div>
        },
        {
            key: "user_display_name",
            label: "Assigned To",
            style: { width: "150px" },
            render: (row) => <div className="text-truncate" title={row?.user_display_name}>{row?.user_display_name}</div>
        },
        {
            key: "project_name",
            label: "Project",
            style: { width: "150px" },
            render: (row) => <div className="text-truncate" title={row?.project_name}>{row?.project_name}</div>
        },
        {
            key: "alloted_bids",
            label: "Bidded Hours",
            style: { width: "100px", textAlign: "center" },
        },
        {
            key: "actual_bids",
            label: "Worked Hours",
            style: { width: "100px", textAlign: "center" },
        },
    ]

    useEffect(() => {
        if (!fromOther && filterValues?.apiCall) {
            getAgileMatrixData();
        }
    }, [filterValues?.apiCall])

    useEffect(() => {
        formatData(data?.matrixData, data?.historyData);
    }, [selectedTab])

    const getAgileMatrixData = async () => {
        try {
            setData((prev) => ({ ...prev, matrixData: [], historyData: [] }));
            setLoader(true);
            const monthPairs = filterValues?.months?.map(item => { return `${item?.month?.toString()?.padStart(2, "0")}/${item?.year}` });
            const payload = {
                project_lead_user_codes: _.pluck(filterValues?.project_leads, "user_code")?.toString() || "",
                requested_user_codes: _.pluck(filterValues?.users, "user_code")?.toString() || "",
                project_ids: _.pluck(filterValues?.projects, "project_id")?.toString() || "",
                project_role_ids: (filterValues?.projects?.length === 0 ? "" : _.pluck(filterValues?.project_role, "project_role_id")?.toString()) || "",
                month_year_range: monthPairs?.toString() || ""
            }
            const res = await services.getInvokeRemote("POST", Urls("GETAGILEMATRIXHEATMAP"), payload);
            if (!res?.body?.error_status) {
                const matrixData = res?.body?.data?.agile_matrix_heatmap_data;
                const historyData = res?.body?.data?.agile_matrix_heatmap_history_data;
                const taskData = res?.body?.data?.agile_matrix_task_details;
                setData((prev) => ({ ...prev, taskData: taskData }))
                formatData(matrixData, historyData);
                setFilterValues(prev => ({ ...prev, apiCall: false }));
                (filterValues?.projects?.length === 0 && !_.isEmpty(filterValues?.project_role)) && setFilterValues((prev) => ({ ...prev, project_role: [] }));
                setLoader(false);
            }
        } catch (error) {
            console.error("Error: ", error);
            setLoader(false);
            setFilterValues(prev => ({ ...prev, apiCall: false }));
        }
    }

    const formatData = (dataArray, historyData) => {
        let arr = [...dataArray]
        arr?.map(item => {
            item["accuracy"] = (selectedTab === "best_performance" ? parseFloat(item?.best_user_accuracy?.toFixed(2)) : parseFloat(item?.bid_accuracy?.toFixed(2))) || 0;
            item["highlightKey"] = selectedTab === "task" ? (item?.total_task ? getRangeKey("total_task", item?.total_task) : "none") : (selectedTab === "bid" ? (item?.accuracy ? "success" : "none") : getColorKey(item?.accuracy));
            item["history"] = _.filter(historyData, his => his?.complexity_id === item?.complexity_id && his?.longitivity_id === item?.longitivity_id);
            item["bestPerformers"] = item?.best_user_performance?.split(",");
        })
        setData((prev) => ({ ...prev, matrixData: arr, historyData }));
    }

    const colorCodes = {
        danger: { background: "#fff1f2", color: "#be123c", border: "#fecdd3" },
        success: { background: "#ecfdf5", color: "#047857", border: "#a7f3d0" },
        warning: { background: "#fffbeb", color: "#b45309", border: "#fde68a" },
        primary: { background: "#eff6ff", color: "#1d4ed8", border: "#dbeafe" },
        secondary: { background: "#f8fafc", color: "black", border: "#e2e8f0" },
        none: { background: "#f8fafc", color: "grey", border: "#e9e9e9" },
        primaryLow: { background: "#eff6ff", color: "#1d4ed8", border: "#dbeafe" },
        primaryMedium: { background: "#dbeafe", color: "#1d4ed8", border: "#bfdbfe" },
        primaryHigh: { background: "#bfdbfe", color: "#1d4ed8", border: "#93c5fd" }
    }

    const getColorKey = (value) => {
        return value === 0 ? "none" : ((value > 105 || value < 0) ? "danger" : ((value <= 105 && value >= 95) ? "success" : (value < 95 ? "warning" : "")))
    }

    const getRangeKey = (key, value) => {
        const vals = _.pluck(data?.matrixData, key);
        const maxValue = Math.max(...vals);
        const percentage = value * 100 / maxValue;
        return percentage > 80 ? "primaryHigh" : percentage > 40 ? "primaryMedium" : percentage > 0 ? "primaryLow" : "none"
    }

    return { tabs, selectedTab, setSelectedTab, data, tooltip, setTooltip, colorCodes, getColorKey, getRangeKey, loader, columns, taskDetails, setTaskDetails }
}